<template>
  <div>
    <Mainlayout></Mainlayout>
    <!-- badan page -->
    <CCard class="h-100">
      <CCol sm="12" class="justify-content-center mt-5 m-0">
        <CContainer>
          <CCol sm="12" lg="12" class="custom-margin mt-5">
            <br />
            <br />
            <br />
            <h3 class="mt-5 text-center mb-3 text-black bold col-12">
              Top Student Rank Taken Quiz
            </h3>
           
          </CCol>
        </CContainer>
      </CCol>
            <CContainer>
       <CCol sm="12" lg="12">
   
              <table style="border:0px" class="table table-responsive-sm">
                <tbody>
                  <tr style="border:0px;padding:0px;margin:0px">
                    <td v-for="(item, index) in rank"
                  v-bind:key="item.studentId" style="border:0px;padding:0px;margin:0px;width:33%">
                      <CCard
                      v-if="index === 1"
                      accent-color="success"
                      class="p-1 bg-silver"
                    >
                      <div class="col-12 text-center mt-4 p-0">
                        <CCardBody>
                          <div class="c-avatar">
                            <span v-if="item.studentProfilePhoto != null">
                              <img
                                :src="getPic(index)"
                                class="m-0 box-shadow small-circle c-avatar-img"
                                style="
                                  border-radius: 50%;
                                  border: 1px solid #eee;
                                "
                              />
                            </span>
                            <span v-else>
                              <img
                                class="m-0 box-shadow small-circle c-avatar-img"
                                src="../assets/img/user.png"
                                style="
                                  border-radius: 50%;
                                  border: 1px solid #eee;
                                "
                              />
                            </span>
                            <span
                              class="c-avatar-status"
                              :class="`bg-${active || 'info'}`"
                              ><span class="small text-white">2nd </span></span
                            >
                          </div>
                          <div
                            class="
                              justify-content-center
                              custom-font
                              text-white
                              mt-3
                            "
                          >
                            {{ item.studentName }}
                            <br />
                            {{ item.totalQuizCount }}
                          </div></CCardBody
                        >
                      </div>
                    </CCard>
                    <CCard
                      v-if="index === 0"
                      accent-color="info"
                      class="p-1 bg-gold"
                    >
                      <div class="col-12 text-center mt-4 p-0">
                        <CCardBody>
                          <div class="c-avatar">
                            <span v-if="item.studentProfilePhoto != null">
                              <img
                                :src="getPic(index)"
                                class="m-0 box-shadow small-circle c-avatar-img"
                                style="
                                  border-radius: 50%;
                                  border: 1px solid #eee;
                                "
                              />
                            </span>
                            <span v-else>
                              <img
                                class="m-0 box-shadow small-circle c-avatar-img"
                                src="../assets/img/user.png"
                                style="
                                  border-radius: 50%;
                                  border: 1px solid #eee;
                                "
                              />
                            </span>
                            <span
                              class="c-avatar-status"
                              :class="`bg-${active || 'info'}`"
                              ><span class="small text-white">1st </span></span
                            >
                          </div>
                          <div
                            class="
                              justify-content-center
                              custom-font
                              text-white
                              mt-3
                            "
                          >
                            {{ item.studentName }}
                            <br />
                            {{ item.totalQuizCount }}
                          </div></CCardBody
                        >
                      </div>
                    </CCard>
                    <CCard
                      v-if="index === 2"
                      accent-color="info"
                      class="p-1 bg-bronze"
                    >
                      <div class="col-12 text-center mt-4 p-0">
                        <CCardBody>
                          <div class="c-avatar">
                            <span v-if="item.studentProfilePhoto != null">
                              <img
                                :src="getPic(index)"
                                class="m-0 box-shadow small-circle c-avatar-img"
                                style="
                                  border-radius: 50%;
                                  border: 1px solid #eee;
                                "
                              />
                            </span>
                            <span v-else>
                              <img
                                class="m-0 box-shadow small-circle c-avatar-img"
                                src="../assets/img/user.png"
                                style="
                                  border-radius: 50%;
                                  border: 1px solid #eee;
                                "
                              />
                            </span>
                            <span
                              class="c-avatar-status"
                              :class="`bg-${active || 'info'}`"
                              ><span class="small text-white">3rd </span></span
                            >
                          </div>
                          <div
                            class="
                              justify-content-center
                              custom-font
                              text-white
                              mt-3
                            "
                          >
                            {{ item.studentName }}
                            <br />
                            {{ item.totalQuizCount }}
                          </div></CCardBody
                        >
                      </div>
                    </CCard>
                    </td>
                  </tr>
                </tbody>
              </table>
            
            </CCol>

            <h3 class="text-center mt-2 mb-4 text-black bold col-12">
              Statistic
            </h3>

            <CCard
            class="ml-4 mr-4"
              style="
                border: 2px solid #009688;
                border-radius: 10px;
                position: relative;
              "
            >
              <h5 class="text-center mt-2 ml-3 mb-4 text-black bold col-10">
                Top 10 Taken Quiz
              </h5>
              <!-- <CChartBar
              style="height:350px"
                :labels="workOrderChartLabel"
                :datasets="workOrderDatasets"
                :options="{
                  responsive: true,
                  maintainAspectRatio: false,
                }"
              /> -->


                <CChartBar
                                style="height:300px"
                                 :labels="workOrderChartLabel"
                                :datasets="workOrderDatasets"
                                :options="defaultOptions"/>
            </CCard>

            <CRow class="ml-3 mr-3">
              <CCol class="col-6">
                <CCard
                  color="light"
                  body-wrapper
                  text-color="black"
                  class="bg-gradient-turqouise"
                  style="height: 120px"
                >
                  <CRow>
                    <CCol class="col-12">
                      <h6
                        class="
                          text-left
                          text-white
                          bold
                          custom-font
                        "
                      >
                        Total Quiz Created
                      </h6>
                    </CCol>

                    <CCol sm="12" lg="12">
                      <h3
                        class="
                          text-left
                          custom-font
                          text-white
                          custom-font
                        "
                      >
                        {{ quiz.quizCount }}
                      </h3>
                    </CCol>
                  </CRow>
                </CCard>
              </CCol>

              <CCol class="col-6">
                <CCard
                  color="light"
                  body-wrapper
                  text-color="black"
                  class="bg-gradient-green"
                  style="height: 120px"
                >
                  <CRow>
                    <CCol class="col-12">
                      <h6
                        class="
                          text-left
                          text-white
                          bold
                          custom-font
                        "
                      >
                        Total Student Take Quiz
                      </h6>
                    </CCol>
                    <CCol sm="12" lg="12">
                      <h3
                        class="
                          text-left
                          custom-font
                          text-white
                          custom-font
                        "
                      >
                        {{ quiz.studentCount }}
                      </h3>
                    </CCol>
                  </CRow>
                </CCard>
              </CCol>
            </CRow>
            </CContainer>
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/backgroundTutor.png";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../containers/TheHeaderCustom.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import { getColor, deepObjectsMerge } from "@coreui/utils/src";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
    Mainlayout,
    CChartBar,
  },
  data() {
    return {
      backgroundBanner,
      rank: [],
      quiz: {},
      top: [],
      workOrderChartLabel: [],
      workOrderDatasets: [
        {
          label: "Quiz Name",
          backgroundColor: "rgb(228,102,81,0.9)",
          data: [30, 39, 10, 50, 30, 70, 35],
        },
      ],
    };
  },
  async mounted() {
    this.GetRank();
    this.GetQuiz();
    this.GetTopQuiz();
  },
  props: {
    ...CChartBar.props,
    backgroundColor: {
      type: String,
      default: "#009688",
    },
    pointHoverBackgroundColor: String,
    dataPoints: {
      type: Array,
      default: () => [10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12],
    },
    label: {
      type: String,
      default: "Most Taken Quiz",
    },
    pointed: Boolean,
  },
  computed: {
    defaultDatasets() {
      return [
        {
          data: this.dataPoints,
          backgroundColor: getColor(this.backgroundColor),
          pointHoverBackgroundColor: getColor(this.pointHoverBackgroundColor),
          label: this.label,
          barPercentage: 0.5,
          categoryPercentage: 1,
        },
      ];
    },
    defaultOptions() {
      return {
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              display: false,
            },
          ],
          yAxes: [
            {
              display: true,
            },
          ],
        },
      };
    },
    computedDatasets() {
      return deepObjectsMerge(this.top.totalQuizCount, this.datasets || {});
    },
    computedOptions() {
      return deepObjectsMerge(this.top.studentName, this.options || {});
    },
  },
  methods: {
    async GetRank() {
      this.$API
        .get(
          this.$QuizTeacherStatisticTopRankStudents +
            "?userId=" +
            this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.rank = response.data;
            this.getPic(this.rank.studentProfilePhoto);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    getPic(index) {
      return "https://pickiddo.com/" + this.rank[index].studentProfilePhoto;
    },
    async GetQuiz() {
      this.$API
        .get(
          this.$QuizTeacherStatisticQuizCount +
            "?userId=" +
            this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.quiz = response.data;
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetTopQuiz() {
      this.$API
        .get(
          this.$QuizTeacherStatisticTopQuizRank +
            "?userId=" +
            this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.top = response.data;
            this.workOrderChartLabel = _.map(response.data, "studentName");
            this.workOrderDatasets[0].data = _.map(
              response.data,
              "totalQuizCount"
            );
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
  },
};
</script>

<style>
.c-avatar .c-avatar-status {
  width: 25px;
  height: 25px;
}
.c-avatar-status {
  position: absolute;
  top: 30px;
  display: block;
  border: 1px solid #fff;
  border-radius: 50em;
  color: #fff;
  text-align: center;
  left: 20px;
}

#fb-root{
  display:none;
}
</style>